module.exports = __webpack_public_path__ + "images/cam4_happy_hour_token-overlay-cf50d6df1e351f37c9babe6a23141c9c.jpg";